module.exports = __webpack_public_path__ + "media/4.d498bb50.mp3";